import _regeneratorRuntime from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _styled from "styled-components";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as HomeIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/athome.svg";
import { ReactComponent as AwayIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/briefcase.svg";
import { ReactComponent as VacationIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/airplane.svg";
import { ReactComponent as SuccessIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/success.svg";
import { usePathCreator } from "../Config/useLinkCreator";
import { useDeviceData } from "../DeviceData/useDeviceData";
import { useDeviceApi } from "../DeviceData/useDeviceApi";
import { Header } from "../Header/Header";
import { ModeRow } from "./ModeRow";

var Container = _styled.div.withConfig({
  displayName: "Hw1ModePage__Container",
  componentId: "sc-15fbo26-0"
})(["display:flex;flex-direction:column;"]);

var Title = _styled.div.withConfig({
  displayName: "Hw1ModePage__Title",
  componentId: "sc-15fbo26-1"
})(["margin-top:60px;font-size:24px;text-align:center;padding:0 40px;"]);

var ModesContainer = _styled.div.withConfig({
  displayName: "Hw1ModePage__ModesContainer",
  componentId: "sc-15fbo26-2"
})(["display:flex;flex:1;flex-direction:column;align-items:center;padding-top:30px;"]);

export function ModePage() {
  var _useDeviceData = useDeviceData(),
      heatConfig = _useDeviceData.heatConfig;

  var _useDeviceApi = useDeviceApi(),
      setModeTemperatures = _useDeviceApi.setModeTemperatures;

  var history = useHistory();
  var pathCreator = usePathCreator();

  var _useState = useState(heatConfig.tx.home),
      _useState2 = _slicedToArray(_useState, 2),
      homeTemp = _useState2[0],
      setHomeTemp = _useState2[1];

  var _useState3 = useState(heatConfig.tx.away),
      _useState4 = _slicedToArray(_useState3, 2),
      awayTemp = _useState4[0],
      setAwayTemp = _useState4[1];

  var _useState5 = useState(heatConfig.tx.vacation),
      _useState6 = _slicedToArray(_useState5, 2),
      vacationTemp = _useState6[0],
      setVacationTemp = _useState6[1];

  var handleSaveClick = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return setModeTemperatures({
                variables: {
                  input: {
                    home: homeTemp,
                    away: awayTemp,
                    vacation: vacationTemp
                  }
                }
              });

            case 2:
              history.push(pathCreator("/"));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSaveClick() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Header, {
    backTo: pathCreator("/"),
    actionIcon: SuccessIcon,
    onAction: handleSaveClick
  }), /*#__PURE__*/React.createElement(Title, null, "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u044B"), /*#__PURE__*/React.createElement(ModesContainer, null, /*#__PURE__*/React.createElement(ModeRow, {
    icon: HomeIcon,
    label: "Дома",
    current: homeTemp,
    min: Math.max(5, awayTemp),
    max: 35,
    onChange: setHomeTemp,
    disabled: heatConfig.manual
  }), /*#__PURE__*/React.createElement(ModeRow, {
    icon: AwayIcon,
    label: "Ушел",
    current: awayTemp,
    min: Math.max(5, vacationTemp),
    max: Math.min(35, homeTemp),
    onChange: setAwayTemp,
    disabled: heatConfig.manual
  }), /*#__PURE__*/React.createElement(ModeRow, {
    icon: VacationIcon,
    label: "Отпуск",
    current: vacationTemp,
    min: 5,
    max: Math.min(35, awayTemp),
    onChange: setVacationTemp
  })));
}